export default __webpack_public_path__ + "static/media/close_icon.ee79fc04.svg";